<template>
  <v-expansion-panels flat>
    <v-expansion-panel
      v-for="client in partnerClients"
      :key="client.id"
    >
      <v-expansion-panel-header>
        <material-overview-partner-client-card :client="client" />
      </v-expansion-panel-header>
      <v-divider />
      <v-expansion-panel-content>
        <material-overview-partner-invoices-and-quotations-cards
          :client-id="client.id"
        />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { MY_VIEW_PATH_SEGMENT } from '@/constants/app'

export default {
  computed: {
    ...mapState('client', ['clients']),
    ...mapActions('client', ['getAllClientsDataIfNeed']),
    partnerClients () {
      const partnerClients = { ...this.clients }
      if (partnerClients[MY_VIEW_PATH_SEGMENT]) {
        delete partnerClients[MY_VIEW_PATH_SEGMENT]
      }
      return partnerClients
    }
  },
  created () {
    // eslint-disable-next-line no-unused-expressions
    this.getAllClientsDataIfNeed
  }
}
</script>
